module.exports = __webpack_public_path__ + "static/media/pattern.18c80f17.svg";